import { useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { getAssetBusinessTypeTranslationKey, getAssetPageTypeTranslationKey, getAssetPageFeatureTranslationKey } from 'marketplace-ui-assets-core/utils/i18n';
export function useStorefrontRouteParamTranslations(routeParams, casing = 'sentence') {
  const {
    businessType,
    pageType,
    pageFeature
  } = routeParams;
  const result = useMemo(() => {
    const _result = {};
    if (businessType) {
      _result.businessType = unescapedText(getAssetBusinessTypeTranslationKey(businessType, casing));
    }
    if (pageType) {
      _result.pageType = unescapedText(getAssetPageTypeTranslationKey(pageType, casing));
    }
    if (pageFeature) {
      _result.pageFeature = unescapedText(getAssetPageFeatureTranslationKey(pageFeature, casing));
    }
    return _result;
  }, [businessType, casing, pageFeature, pageType]);
  return result;
}